import React, { FC } from 'react';

import styled from '@emotion/styled';
import { variant, ComponentsType } from '@lucid/theme';

export interface NavbarItemProps {
  /** The theme object to apply styles to the NavbarItem component. */
  className?: string;
  /** The available variants for the NavbarItem component. */
  variant?: ComponentsType['Navbar']['Item'];
}

const StyledNavbarItem = styled.li<NavbarItemProps>(
  variant({
    scale: 'navbar.item',
    variants: {
      defaultVariant: {}
    }
  }),
  ({ theme }) => ({
    label: 'navbarItem',
    flex: '0 1 auto',
    alignSelf: 'flex-start',
    listStyle: 'none',
    margin: 'auto 0.5rem',
    [`@media (max-width: ${theme.navbar.collapseAt})`]: {
      margin: 0,
      padding: '1rem 2rem',
      width: '100%',
      '& > [data-link-as-button="true"]': {
        display: 'flex',
        justifyContent: 'center'
      }
    }
  })
);

const NavbarItem: FC<NavbarItemProps> = ({ className, variant = 'default', ...rest }) => (
  <StyledNavbarItem {...rest} className={className} variant={variant} />
);

export { NavbarItem };
export default NavbarItem;
